import { render, staticRenderFns } from "./collapse.vue?vue&type=template&id=1982d7d9&lang=html&"
import script from "./collapse.vue?vue&type=script&lang=js&"
export * from "./collapse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Devdoc\\_packages\\moss-ui\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1982d7d9')) {
      api.createRecord('1982d7d9', component.options)
    } else {
      api.reload('1982d7d9', component.options)
    }
    module.hot.accept("./collapse.vue?vue&type=template&id=1982d7d9&lang=html&", function () {
      api.rerender('1982d7d9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/collapse.vue"
export default component.exports